import React from 'react';
import PropTypes from 'prop-types';
import { VaAlert } from '@department-of-veterans-affairs/component-library/dist/react-bindings';
import { VALIDATION_ALERT_HEADING_ID } from '../../util/address-validation/addressValidationFocus';
import { getDynamicHeaderTag } from '../../util/address-validation/getAddressValidationDisplay';

/**
 * The alert above the address options, telling the user why the address they
 * entered needs confirming.
 *
 * The caller decides whether to render this at all: the class suppressed it
 * whenever a transaction error was present, because that error alert already
 * sits in the position right before this component.
 *
 * @param {object} props
 * @param {boolean} [props.addressValidationError] switches the alert from a
 *   warning to an error.
 * @param {object} props.message an ADDRESS_VALIDATION_MESSAGES entry.
 * @param {Function} props.onEditClick handed to the message's ModalText, some
 *   of which render an inline edit link.
 */
export const AddressValidationAlert = ({
  addressValidationError,
  message,
  onEditClick,
}) => {
  const AlertHeader = getDynamicHeaderTag(4);

  return (
    <VaAlert
      className="vads-u-margin-bottom--1 vads-u-margin-top--0"
      status={addressValidationError ? 'error' : 'warning'}
      visible
      slim={message?.slim}
      role="alert"
    >
      {message.headline && (
        <AlertHeader id={VALIDATION_ALERT_HEADING_ID} slot="headline">
          {message.headline}
        </AlertHeader>
      )}
      <message.ModalText editFunction={onEditClick} />
    </VaAlert>
  );
};

AddressValidationAlert.propTypes = {
  message: PropTypes.shape({
    headline: PropTypes.string,
    slim: PropTypes.bool,
    ModalText: PropTypes.elementType.isRequired,
  }).isRequired,
  addressValidationError: PropTypes.bool,
  onEditClick: PropTypes.func,
};

export default AddressValidationAlert;
